<template>
    <upload-process
        v-slot="{ trigger }"
        v-model="background"
        :max-size="1024 * 1024"
        :upload-method="uploadMethod"
        accept="image/*"
        @error="onError"
    >
        <isc-button class="mb12" plain @click="trigger">上传图片</isc-button>
        <p class="greybb">建议上传 1024*768 以上尺寸的图片，尺寸限制在 1MB 以内</p>
    </upload-process>
</template>

<script>
import axios from '@/utils/axios';
import { showError } from '../../../../../utils/message';

export default {
    name: 'TheUploadBackground',

    props: {
        configType: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            background: []
        };
    },

    methods: {
        async uploadMethod(upload, progress) {
            const fd = upload.fd;
            if (!this.testFileType(fd)) return;
            this.appendFormParams(fd);
            const pic = await axios.post('/api/ops/config/picture/upload', fd, {
                onUploadProgress: progress
            });
            this.$emit('success', pic);
        },

        testFileType(fd) {
            const file = fd.get('file');
            if (!file) return false;
            const acceptTypes = ['jpg', 'png'];
            const typeMatch = acceptTypes.some((type) => file.name.endsWith(`.${type}`));
            if (!typeMatch) {
                showError('上传文件格式错误，请上传 jpg、png 格式的图片！');
                return false;
            }
            return true;
        },

        appendFormParams(fd) {
            // 要不要消除副作用
            fd.append('configType', this.configType);
            fd.append('pictureType', 'background');
            fd.append('used', 1);
        },

        onError(upload) {
            showError(upload.error);
        }
    }
};
</script>

<style lang="scss" scoped></style>
